<template>
  <div :class="['radio-button-wrapper', small && 'radio-button-wrapper--small']">
    <div
      @click="onClickHandler"
      :class="[
        'radio-button',
        selected && 'radio-button--checked',
        small && 'radio-button--small',
        disabled && 'radio-button--disabled',
        primary && selected && 'radio-button--checked--primary',
        parentHover && 'radio-button--parent-hover',
        parentClicked && 'radio-button--parent-clicked',
      ]"
    ></div>
    <span
      v-if="selected && !primary"
      :class="['radio-button__check', small && 'radio-button__check--small']"
    ></span>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    primary: {
      type: Boolean,
      required: false,
      default: false,
    },
    parentHover: {
      type: Boolean,
      required: false,
      default: false,
    },
    parentClicked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClickHandler() {
      if (this.$listeners['click-handler'] && !this.disabled) {
        this.$emit('click-handler')
      }
    },
  },
  computed: {
    selected() {
      if (this.disabled) {
        return false
      }
      return this.isSelected
    },
  },
}
</script>

<style lang="scss">
.radio-button {
  $this: &;
  height: 30px;
  width: 30px;
  appearance: none;
  border: 1px solid var(--checkbox-border);
  border-radius: 100%;
  outline: none;
  cursor: pointer;
  position: absolute;
  &--parent-hover {
    border-color: var(--strong-light-green);
  }
  &--parent-clicked {
    border: none;
    background-color: var(--light-blue-gray);
  }
  &-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    height: 30px;
    &--small {
      height: 20px;
    }
  }
  &--checked {
    border-color: var(--strong-light-green);
    &--primary {
      border-width: 10px;
    }
  }
  &--disabled {
    cursor: initial;
    pointer-events: none;
  }
  &--small {
    height: 20px;
    width: 20px;
  }
  &__check {
    pointer-events: none;
    position: absolute;
    &:before {
      display: block;
      position: relative;
      left: -10px;
      top: 10px;
      content: '';
      text-align: center;
      background-color: var(--white);
      border-radius: 100%;
      font-family: var(--font-bold);
      height: 10px;
      width: 10px;
    }
    &--small {
      &:before {
        left: -5px;
        top: 5px;
      }
    }
  }
}
</style>
